import React, { useContext } from "react";
import { Typography } from "@material-ui/core";
import { Box } from "@material-ui/core";
import { Grid } from "@material-ui/core";
import { Container } from "@material-ui/core";
import { FormControl } from "@material-ui/core";
import { FormControlLabel } from "@material-ui/core";
import { Radio } from "@material-ui/core";
import { RadioGroup } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { FormLabel } from "@material-ui/core";
import { TextField } from "@material-ui/core";
import { MenuItem } from "@material-ui/core";
import { FormContext } from "../../util/context";
import { Button } from "@material-ui/core";
const useStyles = makeStyles((theme) =>
  createStyles({
    smallRadioButton: {
      "& svg": {
        width: "1.5em",
        height: "1.5em",
      },
    },
  })
);

const CategoryInfo = () => {
  const [form, setForm] = useContext(FormContext);
  const classes = useStyles();
  return (
    <>
      <Container maxWidth="md">
        <Typography align="center" variant="h4">
          More Information: {form.type}
        </Typography>
      </Container>
      <Box mt={2}>
        <Container maxWidth="md">
          <Grid container={true} spacing={1}>
            <Grid item={true} xs={12}>
              <FormControl size="medium">
                <FormLabel id="select">
                  <Typography variant="h6">
                    How many hours a day do you spend sitting?
                  </Typography>
                </FormLabel>
                <TextField
                  fullWidth
                  variant="outlined"
                  id="select"
                  select
                  value={form.hoursSitting}
                  onChange={(event) =>
                    setForm({
                      ...form,
                      hoursSitting: event.target.value,
                    })
                  }
                >
                  <MenuItem value={0}>0</MenuItem>
                  <MenuItem value={1}>1</MenuItem>
                  <MenuItem value={2}>2</MenuItem>
                  <MenuItem value={3}>3</MenuItem>
                  <MenuItem value={4}>4</MenuItem>
                  <MenuItem value={5}>5</MenuItem>
                  <MenuItem value={6}>6</MenuItem>
                  <MenuItem value={7}>7</MenuItem>
                  <MenuItem value={8}>8</MenuItem>
                  <MenuItem value={9}>9</MenuItem>
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={11}>11</MenuItem>
                  <MenuItem value={12}>12</MenuItem>
                </TextField>
                {form.professionArray.includes("Athlete") && (
                  <>
                    <FormLabel id="demo-radio-buttons-group-label">
                      <Typography variant="h6">
                        What type of athlete are you?
                      </Typography>
                    </FormLabel>
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      defaultValue="female"
                      name="radio-buttons-group"
                      value={form.sportType}
                      onChange={(event) =>
                        setForm({
                          ...form,
                          sportType: event.target.value,
                        })
                      }
                    >
                      <FormControlLabel
                        value="Contact"
                        control={<Radio color="primary" />}
                        label={<Typography variant="h6">Contact</Typography>}
                        className={classes.smallRadioButton}
                      />
                      <FormControlLabel
                        value="Non - Contact"
                        control={<Radio color="primary" />}
                        label={
                          <Typography variant="h6">Non - Contact</Typography>
                        }
                        className={classes.smallRadioButton}
                      />
                      <FormControlLabel
                        value="Combat"
                        control={<Radio color="primary" />}
                        label={<Typography variant="h6">Combat</Typography>}
                        className={classes.smallRadioButton}
                      />
                    </RadioGroup>
                    <FormLabel id="outlined-multiline-flexible">
                      <Typography variant="h6">
                        What sports do you play?
                      </Typography>
                    </FormLabel>
                    <TextField
                      id="outlined-multiline-flexible"
                      variant="outlined"
                      type="text"
                      placeholder="Sports"
                      value={form.sportsPlayed}
                      fullWidth={true}
                      onChange={(event) =>
                        setForm({
                          ...form,
                          sportsPlayed: event.target.value,
                        })
                      }
                    />
                  </>
                )}
              </FormControl>
            </Grid>
            <Grid item={true} xs={12}></Grid>
          </Grid>
        </Container>
        <Button
          variant="contained"
          fullWidth
          color="primary"
          onClick={() =>
            setForm({
              ...form,
              count: form.count + 1,
            })
          }
        >
          Next
        </Button>
      </Box>
    </>
  );
};

export default CategoryInfo;
